import type { JSX } from 'react';

interface LogoProps {
  size?: number;
  className?: string;
  title?: string;
}

export function SurfTimeLogo({
  size = 48,
  className,
  title = 'SurfTime',
}: LogoProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={className}
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <defs>
        <linearGradient id="st-l4bg" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#FFE2C4" />
          <stop offset="100%" stopColor="#0F6E7A" />
        </linearGradient>
      </defs>
      <rect x="5" y="5" width="90" height="90" rx="18" fill="url(#st-l4bg)" />
      <circle cx="50" cy="38" r="15" fill="#FF7A4F" />
      <path
        d="M10 60 Q 25 52, 40 60 T 70 60 T 100 60"
        fill="none"
        stroke="#FCFAF2"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M10 72 Q 25 64, 40 72 T 70 72 T 100 72"
        fill="none"
        stroke="#FCFAF2"
        strokeWidth="2"
        strokeLinecap="round"
        opacity="0.7"
      />
      <path
        d="M10 84 Q 25 76, 40 84 T 70 84 T 100 84"
        fill="none"
        stroke="#FCFAF2"
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.45"
      />
    </svg>
  );
}
